import React, { useEffect, useState } from 'react';
import { 
    Col, Row, Button, CustomInput , Input, Tooltip
} from 'reactstrap';
import api from '../../api/api.js';
import apifunctions from '../../api/functions.js';


const height30 = {
    height: '30px',
}

const min = 0;
const max = 100;

const tooltipStateInitial = {
    show: false, msg: ""
} 

const MargenInput = (props) => {

    const [tooltipState, setTooltipState ] = useState(tooltipStateInitial)

    useEffect(() => {
        setTimeout(() => {
            if(tooltipState.show)
                setTooltipState(tooltipStateInitial);
        }, 1500);
    }, [tooltipState]);

    const {
        showMargen, setShowMargen,
        margen, setMargen
    } = props;

    const changeMargen = (value) => {

        let newMargen = null;

        switch(true){
            case value > max: newMargen= max; break;
            case value < min: newMargen= min; break;
            default: newMargen = value;
        }

        setMargen(newMargen); 
    }

    const saveMargen = () => {

        const successCallback = () => setTooltipState({show:true, msg:"Guardado"});
        
        const failureCallback = () => setTooltipState({show:true, msg:"Falló"});

        apifunctions.post(
            api.consultador.configConsultador,
            null,
            {margen: margen},
            successCallback,
            failureCallback,
            failureCallback
        );
          
    }

    return(
            <Row className="mt-sm-1">
                <CustomInput
                    type="checkbox"
                    id={'margen_show'}
                    label="Margen(%)"
                    checked={showMargen}
                    onClick={(evt) => {
                        evt.preventDefault();
                        setTimeout(() => setShowMargen(!showMargen), 100);
                    }}
                 />
                {
                    showMargen &&
                    <React.Fragment>
                        <Input
                            className="ml-1 w-25"
                            type="number"
                            style={height30}
                            value={margen}
                            onChange={(e) => changeMargen(e.target.value)}
                        />
                        <Button
                            id={'btn-save-margen'}
                            className = {'icon btn-sm h-100 rounded tiny-btn ml-1'}
                            color={'success'}
                            onClick={saveMargen}
                        >
                            <i class="fa fa-save fa-lg"/>
                        </Button>
                        <Tooltip
                            placement={'right'}
                            isOpen={tooltipState.show}
                            target={'btn-save-margen'}
                        >
                            {tooltipState.msg}
                        </Tooltip>
                    </React.Fragment>
                }
            </Row>
         
    );
}

export default MargenInput;


// WEBPACK FOOTER //
// ./src/views/ConsultadorArticulos/MargenInput.js